<form [formGroup]="officeForm" (ngSubmit)="onSubmit()" *ngIf="officeForm">
    <frg-form-input label="Nom du cabinet" id="officeName" errorMessage="Veuillez renseigner le champ" type="text"
        [formGroup]="officeForm" [control]="officeForm.get('officeName')" required="true"></frg-form-input>
    <frg-form-input label="Adresse" id="address" errorMessage="Veuillez renseigner le champ" type="text"
        [formGroup]="officeForm" [control]="officeForm.get('address')" required="true"></frg-form-input>
    <div class="city-container">
        <frg-form-input label="Code postal" id="postalCode" errorMessage="Veuillez renseigner le champ" type="text"
            [formGroup]="officeForm" [control]="officeForm.get('postalCode')"></frg-form-input>
        <frg-form-input label="Ville" id="city" errorMessage="Veuillez renseigner le champ" type="text"
            [formGroup]="officeForm" [control]="officeForm.get('city')" required="true"></frg-form-input>
    </div>
    <frg-form-input #isMsp label="Maison de Santé Pluridisciplinaire" id="isMsp" type="checkbox"
        [formGroup]="officeForm" [control]="officeForm.get('isMsp')" [isCheckLabelAlign]="true"
        (modelChanged)="changeMsp()"></frg-form-input>
    <frg-form-input #isCs label="Centre de Santé" id="isCs" type="checkbox"
        [formGroup]="officeForm" [control]="officeForm.get('isCs')" [isCheckLabelAlign]="true"
        (modelChanged)="changeCs()"></frg-form-input>

    <frg-form-input *ngIf="officeForm.get('isMsp').value || officeForm.get('isCs').value"
        label="Email Administrateur" id="emailAdmin" type="email" [formGroup]="officeForm"
        [control]="officeForm.get('emailAdmin')"
        errorMessage="Le mail saisi est incorrecte">
    </frg-form-input>
    <div class="deployment-status" *ngIf="cabinetId && cabinetId !== 'create'">
      <span class="title">État de déploiement : </span>
      <span class="status">{{deployStatusView}}</span>
    </div>

    <div class="inline-wrapper">
        <table *ngIf="cabinetInfos" class="certificat-table">
            <tbody>
                <tr>
                    <td>
                        <frg-form-input class="certificat-checkbox" label="Certificat DMP établissement" id="certificatDmpExists" type="checkbox"
                            [formGroup]="officeForm" [control]="officeForm.get('certificatDmpExists')" [isCheckLabelAlign]="true"
                        ></frg-form-input></td>
                    <td>
                        <frg-button (activated)="addCertificat('DMP')" fullWidth="true">{{ cabinetInfos.certificatDmpExists ? 'Remplacer' : 'Ajouter' }}</frg-button>
                    </td>
                    <td>
                        <frg-button (activated)="supprimer('DMP')" fullWidth="true" [backgroundColor]="'var(--danger)'" [disabled]="!cabinetInfos.certificatDmpExists">Supprimer</frg-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <frg-form-input class="certificat-checkbox" label="Certificat INSI établissement" id="certificatInsiExists" type="checkbox"
                            [formGroup]="officeForm" [control]="officeForm.get('certificatInsiExists')" [isCheckLabelAlign]="true"
                        ></frg-form-input>
                    </td>
                    <td>
                        <frg-button (activated)="addCertificat('INSI')" fullWidth="true">{{ cabinetInfos.certificatInsiExists ? 'Remplacer' : 'Ajouter' }}</frg-button>
                    </td>
                    <td>
                        <frg-button (activated)="supprimer('INSI')" fullWidth="true" [backgroundColor]="'var(--danger)'" [disabled]="!cabinetInfos.certificatInsiExists">Supprimer</frg-button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="button-wrapper" *ngIf="cabinetId && cabinetId !== 'create'">
            <div class="button" (click)="openMigration()" *ngIf="cabinetInfos.etatDeploiement === 'deploye'">Migration<br>cabinet</div>
            <div class="button" (click)="goToFeaturesManagment()">Activation/Désactivation<br>des fonctionnalités du cabinet</div>
        </div>
    </div>
    <!-- <div *ngIf="cabinetInfos" class="certificat-wrapper">
        <frg-form-input class="certificat-checkbox" label="Certificat DMP établissement" id="certificatDmpExists" type="checkbox"
            [formGroup]="officeForm" [control]="officeForm.get('certificatDmpExists')" [isCheckLabelAlign]="true"
        ></frg-form-input>
        <frg-button (activated)="addCertificat('DMP')">{{ cabinetInfos.certificatDmpExists ? 'Remplacer' : 'Ajouter' }}</frg-button>
        <frg-button (activated)="supprimer('DMP')" [backgroundColor]="'var(--danger)'" [disabled]="!cabinetInfos.certificatDmpExists">Supprimer</frg-button>
    </div>

    <div *ngIf="cabinetInfos" class="certificat-wrapper">
        <frg-form-input class="certificat-checkbox" label="Certificat INSI établissement" id="certificatInsiExists" type="checkbox"
            [formGroup]="officeForm" [control]="officeForm.get('certificatInsiExists')" [isCheckLabelAlign]="true"
        ></frg-form-input>
        <frg-button (activated)="addCertificat('INSI')">{{ cabinetInfos.certificatInsiExists ? 'Remplacer' : 'Ajouter' }}</frg-button>
        <frg-button (activated)="supprimer('INSI')" [backgroundColor]="'var(--danger)'" [disabled]="!cabinetInfos.certificatInsiExists">Supprimer</frg-button>
    </div> -->

    <div style="text-align: center; margin-top: 2rem;" *ngIf="cabinetId && cabinetId !== 'create' && cabinetInfos.etatDeploiement === 'non_deploye'">
      <button type='button' class="deploy-button" (click)="startDeploy()">
        <div>Lancer le déploiement</div>
      </button>
    </div>
    <frg-table *ngIf="cabinetId && cabinetId !== 'create'" [keysBody]="profils" [keysColumn]="profilColumnTable"
        tableButtonHeader="assets/icons-white/user-plus.svg" (onClickHeader)="addUser()"
        tableButton1="assets/icons/trash.svg" tableButton2="assets/icons/edit.svg"
        tableButton3="assets/icons/refresh-cw.svg"
        (onClick1)="removeProfilFromOffice($event)" (onClick2)="editProfilFromOffice($event)"
        (onClick3)="resetPassword($event)"
        (onChangePage)="onChangePage($event)" (onSort)="onSort($event)">
    </frg-table>
    <div class="buttons-container">
        <button class="left-button" *ngIf="cabinetId && cabinetId !== 'create'"
            (activated)="deleteOffice()">Supprimer</button>
        <button class="right-button" type="submit">Sauvegarder</button>
    </div>
</form>
